import cx from "classnames";
import type { ReactElement } from "react";

type Props = Readonly<{
  time: string;
  className?: string;
}>;

export default function TimeCode({ time, className }: Props): ReactElement {
  return (
    <div
      data-testid="time-code"
      className={cx(
        "bg-inverse px-2 rounded-[5px] text-primary-on-dark text-label inline-block",
        className,
      )}
    >
      <span>{time}</span>
    </div>
  );
}
